import Vue from 'vue';
import { FarmClass } from 'Classes/FarmClass';
import { SET_ALL, UPDATE_FARM_DATA, RESET_FARM_DATA, SET_DOCUMENT_AS_READ, SET_FINANCIAL_STATEMENTS_DOCUMENT_AS_READ } from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [UPDATE_FARM_DATA](state, data) {
    state.farmData.$setAll(data);
    return state;
  },
  [RESET_FARM_DATA](state, farmData = {}) {
    Object.assign(state, { isUserWatch: false });
    state.farmData = new FarmClass(farmData);
    return state.farmData;
  },
  [SET_DOCUMENT_AS_READ](state, id) {
    const itemObject = state.farmData.updates_document_folder.find(item => item.id === id);
    if (itemObject) {
      Vue.set(itemObject.meta_data, 'read', true);
    }
  },
  [SET_FINANCIAL_STATEMENTS_DOCUMENT_AS_READ](state, id) {
    const itemObject = state.farmData.financial_statement_document_folder.find(item => item.id === id);
    if (itemObject) {
      Vue.set(itemObject.meta_data, 'read', true);
    }
  },
};
